import React from "react"
import {breakpoints} from "@next/themes"
// eslint-disable-next-line import/no-extraneous-dependencies
import useEmblaCarousel from "embla-carousel-react"

import {TextModel} from "models/Text"
import {useMediaQuery} from "../../hooks/useMediaQuery"
import connect from "./connect"
import CategoryQuickLink from "../categoryQuickLink"
import {CategoryQuickLinkItem} from "../../ducks/categoryQuickLinks/types"
import {
    CategoryQuickLinkItems,
    CategoryQuickLinksRoot,
    CategoryQuickLinksTitle,
    EmblaContainer,
    EmblaSlide,
    EmblaViewport,
    StyledIconButton,
    StyledImageNavigationContainer,
    Icon,
} from "./components"
import env from "../../config/env"

interface CategoryQuickLinksProps {
    items: CategoryQuickLinkItem[]
    text: TextModel
}
const getChevronPath = (icon: string): string => {
    return `${env.REACT_APP_BLOB_STORAGE_PATH.replace(/\/$/, "")}/icons/shared/${icon}`
}

export function CategoryQuickLinks({items, text}: CategoryQuickLinksProps) {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: false,
        align: "start",
        watchDrag: true,
        containScroll: "keepSnaps",
        skipSnaps: true,
    })

    const isMedium = useMediaQuery(`(min-width: ${breakpoints.values.md}px)`)
    const spaceBetween = isMedium ? 32 : 16
    const slidesPerView = isMedium ? 6 : 3

    if (!items.length || isMedium === null) return null

    return (
        <CategoryQuickLinksRoot data-testid="plp-category-quick-links">
            <CategoryQuickLinksTitle>{text.labels.shopNow}</CategoryQuickLinksTitle>
            <CategoryQuickLinkItems>
                <EmblaViewport ref={emblaRef}>
                    <EmblaContainer className="swiper-wrapper">
                        {items.map((quickLink, index) => {
                            return (
                                <EmblaSlide
                                    $spaceBetween={spaceBetween}
                                    $slidesPerView={slidesPerView}
                                    data-index={index}
                                    key={quickLink.href}
                                    className="carousel-slide"
                                >
                                    <CategoryQuickLink {...quickLink} />
                                </EmblaSlide>
                            )
                        })}
                    </EmblaContainer>
                </EmblaViewport>

                <StyledImageNavigationContainer $side="left" $show={isMedium}>
                    <StyledIconButton onClick={() => emblaApi?.scrollPrev()} aria-label={text.labels.previous}>
                        <Icon>
                            <use xlinkHref={getChevronPath("chevron-left.svg")} />
                        </Icon>
                    </StyledIconButton>
                </StyledImageNavigationContainer>

                <StyledImageNavigationContainer $side="right" $show={isMedium} $rotate={180}>
                    <StyledIconButton onClick={() => emblaApi?.scrollNext()} aria-label={text.labels.next}>
                        <Icon>
                            <use xlinkHref={getChevronPath("chevron-left.svg")} />
                        </Icon>
                    </StyledIconButton>
                </StyledImageNavigationContainer>
            </CategoryQuickLinkItems>
        </CategoryQuickLinksRoot>
    )
}

export default connect(CategoryQuickLinks)
